



import MemberListComponent from "@/components/admin/member/memberListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MemberListPage",
  components: {
    MemberListComponent,
  },
})
export default class MemberListPage extends Vue {}
